import { type ApiClient, listQueryParams } from "./client";
import type { ListQuery, Page, StoreDetail, StoreFilters, StoreInput, StorePolicyPatch, StoreRole, StoreRow } from "./types";

/** Stores: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface StoresApi {
  list(query: ListQuery<StoreFilters>): Promise<Page<StoreRow>>;
  get(id: string): Promise<StoreDetail>;
  create(organizationId: string, input: StoreInput): Promise<StoreDetail>;
  update(id: string, patch: Partial<StoreInput>): Promise<StoreDetail>;
  /** Edit the offer policy (offers, negotiation, handoff). */
  updatePolicy(id: string, patch: StorePolicyPatch): Promise<StoreDetail>;
  deactivate(id: string, reason: string): Promise<StoreDetail>;
  activate(id: string): Promise<StoreDetail>;
  /** Add an organization member to the store, or change their role there. */
  setMember(storeId: string, userId: string, role: StoreRole): Promise<StoreDetail>;
}

export function createHttpStoresApi(client: ApiClient): StoresApi {
  return {
    list: (q) => client.call("listStores", { query: listQueryParams(q) }),
    get: (id) => client.call("getStore", { params: { id } }),
    create: (organizationId, input) => client.call("createStore", { params: { id: organizationId }, body: input }),
    update: (id, patch) => client.call("updateStore", { params: { id }, body: patch }),
    updatePolicy: (id, patch) => client.call("updateStorePolicy", { params: { id }, body: patch }),
    deactivate: (id, reason) => client.call("deactivateStore", { params: { id }, body: { reason } }),
    activate: (id) => client.call("activateStore", { params: { id } }),
    setMember: (storeId, userId, role) => client.call("setStoreMember", { params: { id: storeId, userId }, body: { role } }),
  };
}
